import React, {useEffect, useState, useRef} from "react"
import Avatar from 'components/Avatar';
import API from 'API';
import { ToggleButton } from 'react-bootstrap';
import { USER_PROFILE } from "constants/routes"
import { useHistory } from 'react-router-dom';
import Loader from '../../../../components/Loader'
import { useTranslation } from 'react-i18next';

const Channels = () => {
  const [channelsTabsTotal, setChannelsTabsTotal] = useState({});
  const [channelsData, setChannelsData] = useState([]);
  const [channelType, setChannelType] = useState('active');
  const [isLoading, setIsLoading] = useState(false);
  const [lastPage, setLastPage] = useState(1);
  const [page, setPage] = useState(0);
  const [isFound, setIsFound] = useState(true);

  const history = useHistory();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    API.get('/user/channels/totals')
		 .then(resp => setChannelsTabsTotal(resp))
	}, []);
  
  useEffect(() => {
		if(lastPage === page) return;
    setIsLoading(true);
    setIsFound(false);
		API.get(`/user/channels?type=${channelType}&page=${page + 1}`)
			.then((resp) => {
				setChannelsData([...channelsData, ...resp.data])
				setLastPage(resp.meta.last_page)
			})
			.finally(() => setIsLoading(false))
  }, [channelType, page]);

 
  const buttonGroup = [
    { name: channelsTabsTotal?.total, value: '1', vision: t('all')},
    { name: channelsTabsTotal?.active, value: '2', vision: t('active')},
    { name: channelsTabsTotal?.expired, value: '3', vision: t('expired')},
  ];

  const observer = useRef();

  const lastPostElementRef = React.useCallback(
    node => {
      if (isLoading || lastPage === page) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver(post => {
        if (post[0].isIntersecting) {
					setPage(page + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoading]
  ); 

  return (
    <div className="col channel-container p-0">
      <div className='channel-filter-buttons'>
        {buttonGroup.map((btn, idx) => {
          return (
          <ToggleButton
            key={idx}
            id={`radio-${idx}`}
            className="search-button-to-filter btn mr-2"
            type="radio"
            variant="secondary"
            checked={channelType === btn.vision}
            name="radio"
            value={btn.value}
            onClick={() => {
              setChannelType(btn.vision);
              if(channelType !== btn.vision) {
                setPage(0)
                setChannelsData([])
              }
            }}
          >
            {btn.vision} {btn.name}
          </ToggleButton>
        )
        })}
      </div>  
        {channelsData && channelsData.length ? (
          channelsData.map((item, index) => {
            return (
              <div className='d-flex channel-items'
                ref={channelsData.length === index + 1 ? lastPostElementRef : null}
                onClick={() => history.push(USER_PROFILE.replace(':userId?', item.user.id).replace( ':name?', item.user.nickname ? item.user.nickname : ''))}  >
                <Avatar className="channel-list-avatar  " size={40} image={item.user.avatar}  />
                <div className="channel-list-name-wrapper">
                  <p className={'font-size-12 text-light'}> <b>{item.user.name}</b> </p>
                  <p className={'font-size-12 text-purple notifications-type'}>
                    @{item.user.nickname}
                  </p>
                </div>  
              </div>
            )
          })
         )
         : !isFound && !isLoading ? (
           <p className="channels-not-found-text">{t("nothing_found")}</p>
         ) : null }
       <Loader className="channels-loader" isLoadin={isLoading}></Loader> 
    </div>
  )

};

export default Channels;